import { SVGPropsIcon } from 'src/types';

export const Info = (props: SVGPropsIcon) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clip-path="url(#clip0_29702_5226)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.0007 10.5002C13.8585 10.5002 10.5007 13.858 10.5007 18.0002C10.5007 22.1423 13.8585 25.5002 18.0007 25.5002C22.1428 25.5002 25.5007 22.1423 25.5007 18.0002C25.5007 13.858 22.1428 10.5002 18.0007 10.5002ZM8.83398 18.0002C8.83398 12.9376 12.938 8.8335 18.0007 8.8335C23.0633 8.8335 27.1673 12.9376 27.1673 18.0002C27.1673 23.0628 23.0633 27.1668 18.0007 27.1668C12.938 27.1668 8.83398 23.0628 8.83398 18.0002ZM17.1673 14.6668C17.1673 14.2066 17.5404 13.8335 18.0007 13.8335H18.009C18.4692 13.8335 18.8423 14.2066 18.8423 14.6668C18.8423 15.1271 18.4692 15.5002 18.009 15.5002H18.0007C17.5404 15.5002 17.1673 15.1271 17.1673 14.6668ZM18.0007 17.1668C18.4609 17.1668 18.834 17.5399 18.834 18.0002V21.3335C18.834 21.7937 18.4609 22.1668 18.0007 22.1668C17.5404 22.1668 17.1673 21.7937 17.1673 21.3335V18.0002C17.1673 17.5399 17.5404 17.1668 18.0007 17.1668Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_29702_5226">
          <rect width="20" height="20" fill="white" transform="translate(8 8)" />
        </clipPath>
      </defs>
    </svg>
  );
};
